import { render, staticRenderFns } from "./OverviewPart.vue?vue&type=template&id=b2ea498e&scoped=true"
import script from "./OverviewPart.vue?vue&type=script&lang=js"
export * from "./OverviewPart.vue?vue&type=script&lang=js"
import style0 from "./OverviewPart.vue?vue&type=style&index=0&id=b2ea498e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea498e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ea498e')) {
      api.createRecord('b2ea498e', component.options)
    } else {
      api.reload('b2ea498e', component.options)
    }
    module.hot.accept("./OverviewPart.vue?vue&type=template&id=b2ea498e&scoped=true", function () {
      api.rerender('b2ea498e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/OverviewPart.vue"
export default component.exports